import { skipToken, useQuery } from '@tanstack/react-query';
import type { UpcomingBill } from '@/api/contract';
import { useTRPC } from '@/api/query';
import { useSession } from '@/lib/session';
import type { NavBadge } from './nav';

/** Counts for nav badges: unreviewed transactions and bills due in the next 7 days. */
export const useNavBadges = (): Record<NavBadge, number> => {
  const trpc = useTRPC();
  const { entityId } = useSession();
  const unreviewed = useQuery(
    trpc.transactions.unreviewedCount.queryOptions(entityId ? { entityId } : skipToken, { meta: { silent: true }, staleTime: 60_000 }),
  );
  const bills = useQuery(
    trpc.recurring.upcoming.queryOptions(entityId ? { entityId, days: 7 } : skipToken, { meta: { silent: true }, staleTime: 5 * 60_000 }),
  );
  const count: number | undefined = unreviewed.data;
  const upcoming: UpcomingBill[] | undefined = bills.data;
  return { unreviewed: count ?? 0, bills: upcoming?.length ?? 0 };
};

export const badgeLabel = (badge: NavBadge, n: number): string =>
  badge === 'unreviewed' ? `${n} to review` : `${n} ${n === 1 ? 'bill' : 'bills'} due this week`;
